<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <audio ref="speaker" src="@/assets/media/tellme.mp3" v-show="false"></audio>
    <router-view v-if="isRouterAlive"></router-view>
    <my-image-view :urlList="pictures" :show="show"></my-image-view>
  </div>
</template>

<script>
import Vue from "vue";
import MyImageView from '@/components/MyImageView.vue';
export default {
  name: "App",
  components:{
    MyImageView
  },
  provide() {
    //副组件通过provide 提供变量,子组件通过inject来注入
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      playTask: null,
      playSuccess: false,
      checkTask: null,
      showPlayTips: {
        isMe: false,
      },
      pictures:[],
      show:false
    };
  },
  mounted() {
    this.$refs.speaker.muted = true;
    Vue.prototype.startPlay = this.startPlay;
    Vue.prototype.endPlay = this.endPlay;
    Vue.prototype.$showPlayTips = this.showPlayTips;
    Vue.prototype.playNow = this.playNow;
    Vue.prototype.$showImages = this.showPic
    Vue.prototype.$hideImages = this.hidePic
  },
  methods: {
    async playNow() {
      this.$refs.speaker.muted = false;
      this.$refs.speaker.play();
      this.showPlayTips.isMe = false;
    },
    async play(real) {
      const promise = this.$refs.speaker.play();
      promise
        .then(() => {
          this.playSuccess = true;
          this.showPlayTips.isMe = false;
          if (this.checkTask) {
            clearInterval(this.checkTask);
          }
          setTimeout(() => {
            this.$refs.speaker.muted = false;
          }, 5000);
        })
        .catch((err) => {
          this.playSuccess = false;
          if (real && !this.showPlayTips.isMe) {
            this.showPlayTips.isMe = true;
          }
          // 播放失败，一直尝试
          // if(!this.checkTask){
          //   this.checkTask = setInterval(() => {
          //     this.play()
          //   }, 3000);
          // }
        });
    },
    async startPlay() {
      // if(process.env.NODE_ENV == 'development'){
      //   return
      // }
      let userdata = this.$TOOLS.getUserInfo() || "";
      if (!userdata) {
        await this.$API
          .wtl_personalInfo({
            istips: false,
          })
          .then((res) => {
            this.userdata = res.data.result || "";
            window.localStorage.setItem(
              "userInfo",
              JSON.stringify(this.userdata)
            );
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.userdata = userdata;
      }
      // 登录已经做了开启，这里从页面刷新进来的就不需要了
      if (this.playTask) {
        return;
      }
      if (!this.userdata.isJieDanYuan) {
        return;
      }
      // 播放一次，让权限放开
      if (!this.playSuccess) {
        this.play();
      }
      // 循环查询，渠道数据就要播放一次
      this.playTask = setInterval(() => {
        this.searchOrderAndPlay();
      }, 6000);
    },
    async searchOrderAndPlay() {
      const res = await this.$API.getWeiJieDan();
      const count = res.data.result;
      if (count > 0) {
        this.play(true);
      }
    },
    async endPlay() {
      if (this.playTask) {
        clearInterval(this.playTask);
      }
      if (this.checkTask) {
        clearInterval(this.checkTask);
      }
      this.playTask = null
      this.checkTask = null
    },
    reload() {
      //刷新页面
      // this.isRouterAlive = false;
      // this.$nextTick(function () {
      //     this.isRouterAlive = true;
      // });
    },
    async showPic(documentStatus,documentNumbers){
      const res = await this.$API.filesV5({
        documentStatus,
        documentNumbers : documentNumbers instanceof Array ? documentNumbers : [documentNumbers]
      })
      const result = res.data.result
      if(!result){
        this.$message.warning('没有可查看的图片')
        return
      }
      this.pictures = result.map(item=>item.fileUrl)
      console.log(this.pictures)
      this.show = true
    },
    async hidePic(){
      this.show = false
    }
  },
};
</script>

<style lang='less'>
* {
  touch-action: pan-y;
}
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
